<app-guest-auth-main-layout>
  <ng-template>
    <form
      (ngSubmit)="login(staffLoginForm.value)"
      [formGroup]="staffLoginForm"
      autocomplete="off"
      class="mt-2 w-full px-3 md:text-md text-sm"
      novalidate
    >
      <div class="grid grid-cols-2 md:gap-3 gap-1 mb-4">
        <div (click)="changedValue('nidaValue')"
             class="p-2 cursor-pointer flex items-center gap-2 justify-center text-center border border-primary-500 "
             [ngClass]="{' text-gray-600': optionValue !=='nidaValue', 'bg-primary-500 text-secondary-500': optionValue ==='nidaValue'}">

          <mat-icon svgIcon="group"></mat-icon>
          <span>  {{ "Tumia Jamii Namba"|concat|translate }}     </span>
        </div>

        <div (click)="changedValue('emailValue')"
             class="p-2 cursor-pointer flex items-center gap-2 justify-center text-center border border-primary-500 "
             [ngClass]="{'text-gray-600': optionValue !=='emailValue', 'bg-primary-500 text-secondary-500': optionValue ==='emailValue'}">
          <mat-icon svgIcon="email1"></mat-icon>
          <span>
                {{ "Tumia Barua Pepe"|concat|translate }}
             </span>
        </div>
      </div>

      <div *ngIf="optionValue ==='emailValue'">
        <mat-form-field
          appearance="outline"
          class="material-form w-full"
        >
          <mat-label class="text-dark  faded">{{ "Barua Pepe"|concat|translate }}</mat-label>
          <input
            formControlName="email"
            matInput
            placeholder="Email"
          />
          <mat-icon class="mx-2" matSuffix svgIcon="email1"></mat-icon>
        </mat-form-field>
      </div>

      <div *ngIf="optionValue ==='nidaValue'">
        <mat-form-field
          appearance="outline"
          class="material-form w-full"
        >
          <mat-label class="text-dark faded">{{ "JN"|concat|translate }}</mat-label>
          <input
            #input
            [showMaskTyped]="true"
            formControlName="email"
            mask="99999999-99999-99999-99"
            matInput
            required
          />
          <mat-icon class="mx-2" matSuffix svgIcon="email1"></mat-icon>
        </mat-form-field>
      </div>


      <mat-form-field
        *ngIf="!!optionValue"
        appearance="outline"
        class="material-form w-full"
      >
        <mat-label class="">{{ "Nywila"|concat|translate }}</mat-label>
        <input
          [type]="showPassword ? 'text' : 'password'"
          formControlName="password"
          matInput
          placeholder="{{'Nywila'|concat|translate}}"
        />
        <div
          (click)="togglePasswordVisibility()"
          class="mx-3"
          matSuffix
        >
          <mat-icon
            [svgIcon]="showPassword ? 'view_off' : 'view'"
          ></mat-icon>
        </div>
        <mat-error>
            <span
              *ngIf="
                !staffLoginForm.get('password').valid &&
                staffLoginForm.get('password').touched
              "
            > {{ "Nywila inahitajika"|concat|translate }}</span
            >
        </mat-error>
      </mat-form-field>
      <div
        class="w-full md:flex-row flex-col flex items-center bg-white mb-2 border gap-1 border-primary-200 rounded-xl p-2.5 ">
        <img src="data:image/png;base64,{{captchaImage}}" class="w-1/4" alt="captcha_image">
        <div class="flex items-center flex-grow">
          <input [(ngModel)]="captchaInput" [ngModelOptions]="{standalone: true}" type="text"
                 class="bg-white border rounded-md p-2 mr-2 ml-1">
          <button type="button" (click)="generateCaptcha()" class="ml-2">
            <mat-icon>refresh</mat-icon>
          </button>
        </div>
        <button (click)="verifyCaptcha()" type="button"
                class="rounded-lg md:self-end self-center ml-2 px-3 py-2 text-secondary-500 bg-primary-500">
          {{ "Thibitisha"|concat|translate }}
        </button>
      </div>
      <p class="text-red-600">{{ captchaErrMsg }}</p>
      <div class="flex flex-col gap-2 w-full justify-between">
              <span routerLink="/forgot-password"
                    class="text-[#0F2167] font-medium cursor-pointer text-lg">{{ "Je umesahau neno la siri?"|concat|translate }}</span>
        <button type="submit"
                [disabled]="!captchaVerify"
                [ngClass]="{
                          'cursor-not-allowed bg-gray-300 text-gray-700': !captchaVerify,
                          'bg-primary-500 text-white': captchaVerify
                        }"
                class="rounded-sm px-3 py-2.5 w-full text-lg">
          <span>{{ "Ingia"|concat|translate }}</span>
        </button>
      </div>
    </form>

    <div class="text-center py-3 text-lg">
      {{ "Je haujajisajili?"|concat|translate }} <span class="text-[#0F2167] underline font-medium cursor-pointer"
                                                       routerLink="/register">{{ "Tengeneza akaunti."|concat|translate }}</span>
    </div>
  </ng-template>
</app-guest-auth-main-layout>
